import css from 'styled-jsx/css';
import { colors, fonts, screen } from 'components/styles/variables';

export default css`
  .quick-picks-container {
    margin: 0 auto;
    border-radius: 16px;
    font-family: ${fonts.default};
    display: flex;
    flex-direction: column;
    text-align: left;
    width: 100%;
    max-width: 320px;
    height: 282px;
    padding: 0px 16px;
    background: ${colors.WHITE};
    position: relative;
    box-sizing: border-box;
  }

  @media (min-width: ${screen.smMin}) {
    .quick-picks-container {
      padding: 0px 34px;
      box-sizing: border-box;
      height: 503px;
      max-width: 668px;
    }
  }

  .vehicle-card {
    position: absolute;
    box-sizing: border-box;
    bottom: 0;
    width: calc(100% - 32px);
    max-width: 288px;
    padding-bottom: 16px;
  }

  @media (min-width: ${screen.smMin}) {
    .vehicle-card {
      width: 100%;
      padding-bottom: 24px;
      max-width: 600px;
    }
  }

  .quick-picks-header {
    display: flex;
    justify-content: center;
    margin-bottom: 32px;
  }

  .quick-picks-title {
    font-weight: bold;
    line-height: 1.36;
    color: ${colors.WHITE};
    font-size: 20px;
    letter-spacing: 0.2px;
    text-align: center;
  }

  @media (min-width: ${screen.smMin}) {
    .quick-picks-title {
      font-size: 30px;
      letter-spacing: 0.29px;
    }
  }

  .quick-picks-image-container {
    display: flex;
    margin-bottom: 8px;
    margin-right: 0;
    margin-left: 0;
    justify-content: center;
    height: auto;
    position: relative;
    width: 100%;
    height: 157px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0px 10px 16px rgba(0, 0, 0, 0.2);
  }

  @media (min-width: ${screen.smMin}) {
    .quick-picks-image-container {
      width: 600px;
      height: 326px;
      margin-bottom: 16px;
    }
  }

  .quick-picks-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: auto;
    margin: 0;
    border-radius: 16px;
  }

  .quick-picks-vehicle-details {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  @media (min-width: ${screen.smMin}) {
    .quick-picks-vehicle-details {
      margin-bottom: 16px;
    }

    .quick-picks-vehicle-details h2 {
      max-height: 64px;
    }
  }

  .quick-picks-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: auto;
  }

  .quick-picks-actions .div {
    margin-right: 5px;
  }

  h2 {
    margin: 0;
    font-weight: 700;
    font-size: 18px;
    max-width: 420px;
    padding-right: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: ${colors.BLACK};
  }

  @media (min-width: ${screen.smMin}) {
    h2 {
      font-size: 24px;
    }
  }

  .snapshot {
    width: 100%;
    border-bottom: 1px solid ${colors.G2};
    display: flex;
    margin-bottom: 16px;
  }

  @media (min-width: ${screen.smMin}) {
    .snapshot {
      margin-bottom: 24px;
    }
  }

  .dealer-name {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.2px;
    padding: 2px 12px 10px 1px;
    border-right: 1px solid ${colors.G2};
    color: ${colors.BLACK};
  }

  @media (min-width: ${screen.smMin}) {
    .dealer-name {
      font-size: 18px;
      padding: 2px 18px 10px 1px;
    }
  }

  .location {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.2px;
    padding: 2px 0px 10px 12px;
    color: ${colors.BLACK};
  }

  @media (min-width: ${screen.smMin}) {
    .location {
      font-size: 18px;
      padding: 2px 0px 10px 18px;
    }
  }
`;
